import Api from "./Api";
import Utils from "../utilities/Utils";
import {
  PeppolSearchParams,
  PeppolSearchResult,
  UBLData,
  UBLExtractionData,
} from "../types";

export default class PeppolController extends Api {
  static search(params: PeppolSearchParams): Promise<PeppolSearchResult> {
    return fetch(`/api/peppol/search?${Utils.encodeQueryData(params)}`, {
      method: "GET",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }

  static parse(xml: string): Promise<UBLData> {
    return fetch("/api/peppol/parse", {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
      body: JSON.stringify({ xml: xml }),
    }).then((res) => res.json());
  }

  static offboard(id: string): Promise<{ success?: boolean; errors?: { field: string; value: string }[] }> {
    return fetch(`/api/peppol/${id}/offboard`, {
      method: "DELETE",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        Authorization: this.token,
      },
      credentials: "same-origin",
    }).then((res) => res.json());
  }
}
